<template>
  <div class="header-wrap">
    <ul class="nav-bar-menu">
      <li class="logo-wrap">
        <router-link :to="{ name: 'News' }" v-if="!isDeleted">
            <logo-icon></logo-icon>
            <!--<img src="@/assets/logo.svg" alt="Logo" class="logo" />-->
          </router-link>
          <router-link
            v-else
            :to="{ name: 'Profile', params: { id: profile.userId } }"
          >
              <logo-icon></logo-icon>
            <!--<img src="@/assets/logo.svg" alt="Logo" class="logo" /> -->
        </router-link>
      </li>
        <li
          class="nb-menu-item nb-menu-iconEffect"
          :class="{ 'nb-menu-item--active': isActive('Profile') }"
          :data-descr="$t('menu.profile')"
          v-show="!isDeleted"
        >
          <router-link :to="{ name: 'Profile', params: { id: profile.userId } }">
              <profile-icon></profile-icon>
          </router-link>
        </li>
        <li
            class="nb-menu-item nb-menu-iconEffect"
            :data-descr="$t('menu.chat')"
            :class="{ 'nb-menu-item--active': isActive('ChatsRoot') }"
            v-show="!isDeleted"
        >
            <router-link class="chats-nav-link" :to="{ name: 'ChatsRoot' }">
                <chat-icon></chat-icon>
                <div v-if="unreadChatsCount > 0" class="unread-chats-ind">
                    {{ unreadChatsCount }}
                </div>
            </router-link>
        </li>
        <li
          class="nb-menu-item nb-menu-iconEffect"
          :class="{ 'nb-menu-item--active': isActive('Friends') }"
          :data-descr="$t('menu.friends')"
          v-show="!isDeleted"
        >
          <router-link :to="{ name: 'Friends' }">
            <friends-icon></friends-icon>
          </router-link>
        </li>
        <li
            class="nb-menu-item nb-menu-iconEffect"
            :data-descr="$t('menu.groups')"
            :class="{ 'nb-menu-item--active': isActive('Groups') }"
            v-show="!isDeleted"
        >
            <router-link :to="{ name: 'GroupsList', params: { type: 'my' } }">
                <groups-icon></groups-icon>
            </router-link>
        </li>
      <li
        class="nb-menu-item nb-menu-iconEffect"
        :data-descr="$t('menu.photo')"
        :class="{ 'nb-menu-item--active': isActive('Photo') }"
        v-show="!isDeleted"
      >
        <router-link :to="{ name: 'Photo' }">
            <photos-icon></photos-icon>
        </router-link>
      </li>
      <li
        class="nb-menu-item nb-menu-iconEffect"
        :data-descr="$t('menu.manipulator')"
        :class="{ 'nb-menu-item--active': isActive('Manipulators') }"
        v-show="!isDeleted"
      >
        <router-link :to="{ name: 'ManipulatorsList' }">
          <manipulators-icon></manipulators-icon>
        </router-link>
      </li>
      <li
        class="nb-menu-item nb-menu-iconEffect"
        :data-descr="$t('menu.news')"
        :class="{ 'nb-menu-item--active': isActive('News') }"
        v-show="!isDeleted"
      >
        <router-link :to="{ name: 'News' }">
          <news-icon></news-icon>
        </router-link>
      </li>
      <li
        class="nb-menu-item nb-menu-iconEffect"
        :data-descr="$t('menu.aboutProject')"
        v-show="!isDeleted"
      >
        <router-link :to="{ name: 'About' }">
          <about-icon></about-icon>
        </router-link>
      </li>
      <li class="search-wrap" v-show="!isDeleted">
        <!-- <el-select
          v-model="searchOption"
          :placeholder="$t('common.search')"
          class="nb-search-select"
        >
          <el-option
            v-for="item in SEARCH_OPTIONS"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select> -->
        <input
          v-model="searchString"
          type="text"
          class="nb-search"
          @keyup.enter="search"
          :placeholder="$t('common.search')"
        />
        <el-button text @click="search"
          ><i class="fas fa-search nb-search-icon"></i
        ></el-button>
      </li>
      <li class="search-wrap" v-show="isDeleted"></li>
      <li>
        <theme-switch></theme-switch>
      </li>
      <li class="nb-menu-iconEffect" v-show="!isDeleted" v-click-outside="closeNotify">
        <a href="#"  @click="notifyDialog = !notifyDialog" class="chats-nav-link">
            <notification-icon></notification-icon>
            <div v-if="unviewedNotificationsCount > 0" class="unread-notify-ind">
            {{ unviewedNotificationsCount }}
          </div>
        </a>
        <div class="parent-relative">
          <notify-dialog
            v-if="notifyDialog"
          ></notify-dialog>
        </div>
      </li>
      <li
        class="avatar-wrap"
        @click="toggleProfileMenu"
        v-click-outside="closeProfileMenu"
      >
        <user-avatar
          v-if="!loadPersonIcon"
          :user="currentUser"
          :navigate-on-click="false"
          :show-bulb="false"
          :factor="1.3"
          @no-content="loadPersonIcon = true"
        ></user-avatar>
        <icon-person :width="27" :height="27" v-if="loadPersonIcon" />
        <div v-if="showProfileMenu" class="profile-menu">
          <div @click="profileEdit">
            {{ $t("menu.profileSettings") }}
          </div>
          <div @click="profileLogOut">
            {{ $t("menu.signOut") }}
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import UserAvatar from "@/components/avatars/UserAvatar";
import notifyDialog from "@/components/Notifications/notifyDialog.vue";
import themeSwitch from "./themeSwitch";
import ChatInput from '@/components/chats/ChatInput.vue';
import FriendsIcon from '@/components/icons/navbarIcon/FriendsIcon.vue';
import PhotosIcon from '@/components/icons/navbarIcon/PhotosIcon.vue';
import ManipulatorsIcon from '@/components/icons/navbarIcon/ManipulatorsIcon.vue';
import NewsIcon from '@/components/icons/navbarIcon/NewsIcon.vue';
import AboutIcon from '@/components/icons/navbarIcon/AboutIcon.vue';
import NotificationIcon from '@/components/icons/navbarIcon/NotificationIcon.vue';
import LogoIcon from '@/components/icons/navbarIcon/LogoIcon.vue';
const SEARCH_OPTIONS = {
  people: { value: 1, label: "Люди" },
  groups: { value: 2, label: "Группы" },
};

export default {
  components: {
    LogoIcon,
    NotificationIcon,
    AboutIcon,
    NewsIcon,
    ManipulatorsIcon,
    PhotosIcon,
    FriendsIcon,
    ChatInput,
    "user-avatar": UserAvatar,
    notifyDialog,
    themeSwitch
  },
  data() {
    return {
      SEARCH_OPTIONS: SEARCH_OPTIONS,
      showProfileMenu: false,
      searchOption: SEARCH_OPTIONS.people.value,
      searchString: null,
      loadPersonIcon: false,
      notifyDialog: false
    };
  },
  async created() {
    await this.loadUnreadChatsCount()
  },
  computed: {
    ...mapState("context", ["profile"]),
    ...mapGetters("context", ["isDeleted"]),
    ...mapState("cache", ["chats"]),
    ...mapState("cache", ["notificationsAmount"]),
    ...mapState("cache", ["currentUser"]),
    ...mapState("cache", ["unreadChatsCount"]),
    unviewedNotificationsCount(){
      return this.notificationsAmount;
    }
  },
  methods: {
    ...mapActions("context", ["logout"]),
    ...mapActions("cache", ["loadUnreadChatsCount"]),
    closeNotify() {
      this.notifyDialog = false;
    },

    profileLogOut() {
      this.logout().then(() => {
        const domain = `${window.location.protocol}//${window.location.host}`;
        window.location.replace(`${domain}/authorization`);
      });
    },
    profileEdit() {
      this.$router.push({ name: "EditProfile" });
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
    closeProfileMenu() {
      this.showProfileMenu = false;
    },
    isActive(name) {
      return this.$route.name == name;
    },
    search() {
      if (this.searchOption && this.searchString) {
        switch (this.searchOption) {
          case SEARCH_OPTIONS.people.value:
            this.$router.push({
              name: "Search",
              params: { search: this.searchString.trim() },
            });
            this.reset();
            break;
        }
      }
    },
    reset() {
      this.searchOption = null;
      this.searchString = null;
    },
  },
};
</script>

<style lang="scss">
.events-badge .el-badge__content {
  border: none;
  border-radius: 10px;
}
.svg--active {
  fill: var(--nav-menu-active-icon) !important;
}
.nb-menu-item--active {
  border-bottom: 2px solid var(--nav-menu-active-icon) !important;
}
.profile-menu div {
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 22px;
  color: var(--nav-menu-text);
  padding: 9px 20px 9px 20px;
  min-width: 140px;
}
.profile-menu div:hover {
  background-color: var(--nav-menu-background-hover);
}
.nb-menu-item[data-descr]:hover::after {
  content: attr(data-descr);
  position: absolute;
  top: 62px;
  min-width: 54px;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  background-color: var(--nav-menu-background);
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  text-align: center;
  color: var(--nav-menu-text);
  padding-top: 3px;
  padding-left: 8px;
  padding-right: 8px;
  padding-bottom: 6px;
  z-index: 1;
  box-shadow: 0px 4px 4px var(--box-shadow);
}
.header-wrap {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
}
.header-wrap .nav-bar-menu {
  background-color: var(--nav-menu-background);
  border-radius: 0 0 5px 5px;
  margin: 0 auto;
  width: 1200px;
  list-style-type: none;
  display: flex;
  height: 60px;
  border-left: 1px solid var(--nav-menu-border);
  border-bottom: 1px solid var(--nav-menu-border);
  border-right: 1px solid var(--nav-menu-border);
  padding: 0;
  box-shadow: 0px 4px 4px var(--box-shadow);
}
.header-wrap .nav-bar-menu li {
  display: flex;
  list-style: none;
  align-items: center;
  justify-content: center;
  padding: 0px 0;
  height: inherit;
  box-sizing: border-box;
  width: 70px;
}

.header-wrap .nav-bar-menu li a {
  color: var(--nav-menu-icon);
  text-align: center;
  text-decoration: none;
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  border-right: 1px solid var(--nav-menu-item-border);
}
.header-wrap .nav-bar-menu li:last-child a {
  border-right: none;
}

.header-wrap .nb-menu-item {
  width: 77px;
  border-bottom: 2px solid var(--nav-menu-item-border-bottom);
}
.header-wrap .nb-menu-item svg {
  // fill: var(--nav-menu-icon);
}
.header-wrap .nb-menu-item:hover {
  border-bottom: 2px solid var(--nav-menu-active-icon);
}
.header-wrap .nb-menu-item:hover svg {
  // fill: var(--nav-menu-active-icon);
}

.header-wrap .nav-bar-menu li.search-wrap {
  flex-grow: 1;
  position: relative;
}
.header-wrap .nb-search-select {
  position: absolute;
  left: 35px;
  width: 100px;
  background: none;
}
.header-wrap .nb-search-select .el-input__inner {
  line-height: 18px;
  color: var(--nav-menu-icon);
  border: none;
}
.header-wrap .nb-search-select .el-input__inner::placeholder {
  color: var(--nav-menu-icon);
}
.header-wrap .nb-search {
  background-color: var(--backgroundColor);
  border: none;
  border-radius: 8px;
  height: 40px;
  outline: 0;
  box-sizing: border-box;
  padding: 0 0px 0 35px;
  width: 100%;
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--nav-menu-text);
}
.nb-search::placeholder {
  font-family: "Lato";
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  color: var(--nav-menu-icon);
}
.header-wrap .nb-search-icon {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 16px;
  font-size: 1.5em;
  color: var(--nav-menu-icon);
  font-weight: 500;
}

.header-wrap .avatar-wrap {
  cursor: pointer;
  position: relative;
}
.header-wrap .profile-menu {
  position: absolute;
  top: 60px;
  left: -1px;
  background-color: var(--nav-menu-background);
  border: 1px solid var(--nav-menu-border);
  border-radius: 5px;
  box-shadow: 0px 4px 4px var(--box-shadow);
  padding-top: 10px;
  padding-bottom: 10px;
}
.header-wrap .profile-menu a {
  font-size: 16px !important;
  width: unset !important;
  padding: 5px 20px;
  justify-content: start !important;
}
.header-wrap .profile-menu .el-divider {
  margin: 2px auto;
  width: 80%;
}
.header-wrap .logo-wrap {
  width: 90px !important;
}
.header-wrap .logo {
  height: 40px;
}

.header-wrap .chats-nav-link {
  position: relative;
}
.header-wrap .unread-chats-ind {
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  right: 8px;
  bottom: 4px;
  z-index: 101;
  color:var(--whiteText);
  background-color: var(--nav-menu-icon);
  font-size: 11px;
  border-radius: 8px;
  border: 1px solid white;
  box-sizing: border-box;
}
.header-wrap .unread-notify-ind{
  position: absolute;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  right: 8px;
  bottom: 30px;
  z-index: 101;
  color:var(--whiteText);
  background-color: var(--nav-menu-icon);
  font-size: 11px;
  border-radius: 8px;
  border: 1px solid white;
  box-sizing: border-box;
}
</style>

<style scoped>
.el-button.is-text:not(.is-disabled):focus, .el-button.is-text:not(.is-disabled):hover {
    background-color: rgba(0, 0, 0 ,0);
}
</style>
